import Vue from "vue";
import "./plugins/bootstrap-vue";
import "./plugins/custom-style";
import App from "./App.vue";
import router from "./router";
import VueRouter from "vue-router";
import { i18n, loadJSONLabels } from "./i18n";
import store from "./store";
import { Component } from "vue-property-decorator";
import { getGlobalData } from "./services/global.service";
import {
  UPDATE_ANSWERS,
  ACTION_INIT_DEFAULT_SETTINGS,
  ACTION_INIT_DATAS,
  UPDATE_LOADED,
} from "./store/operators";
import { forkJoin } from "rxjs";
import { mapQuestionDtoToAnswers } from "./services/mapper.service";
import VueSanitize from "vue-sanitize";
import VueGtm from '@gtm-support/vue2-gtm';


//Vue sanitize config
const defaults = VueSanitize.defaults;
//Authorize class tag to allow magnolia contributors to use bootstrap and customs css classes
defaults.allowedAttributes["div"] = ["class"];
defaults.allowedAttributes["p"] = ["class"];
defaults.allowedAttributes["span"] = ["class"];
defaults.allowedAttributes["ul"] = ["class"];
defaults.allowedAttributes["li"] = ["class"];
defaults.allowedAttributes["ol"] = ["class"];
defaults.allowedAttributes["a"].push("class");
defaults.allowedAttributes["img"].push("class");
defaults.allowedAttributes["h1"] = ["class"];
defaults.allowedAttributes["h2"] = ["class"];
defaults.allowedAttributes["h3"] = ["class"];
defaults.allowedAttributes["h4"] = ["class"];
defaults.allowedAttributes["h5"] = ["class"];
defaults.allowedAttributes["label"] = ["class"];
Vue.use(VueSanitize, defaults);

import VueCompositionAPI from "@vue/composition-api";
//GTM containerId
const gtmIdentifiant = sessionStorage.getItem('gtmContainerId');

Vue.use(VueCompositionAPI);
Vue.use(VueRouter);
Component.registerHooks(["setup", "validations"]);
Vue.config.productionTip = false;
if (gtmIdentifiant) {
  Vue.use(VueGtm, {
    id: gtmIdentifiant,
    enabled: true,
    debug: true,
    vueRouter: router,
  });
}

declare global {
  interface Window {
    abacaConfig: {
      urls: {
        URL_ContextPath: string;
        URL_JSONdata: string;
        URL_GetPDF: string;
        URL_SendStats: string;
        URL_GetExcel: string;
        URL_GetEquipments: string;
      };
      excel_config: string;
      i18n_filename: string;
      defaultImg: string;
      customEquipmentImg: string;
    };
  }
}

/**
 * used in Vue beforeCreate lifecycle hook. Init instance properties based on abaca properties.
 * Then load the right i18n file depending on instance name.
 */
function initInstanceProperties() {
  if (window !== undefined && window.abacaConfig !== undefined) {
    Vue.prototype.URL_ContextPath = window.abacaConfig.urls.URL_ContextPath;
    Vue.prototype.URL_JsonData = window.abacaConfig.urls.URL_JSONdata;
    Vue.prototype.URL_GetPDF = window.abacaConfig.urls.URL_GetPDF;
    Vue.prototype.URL_SendStats = window.abacaConfig.urls.URL_SendStats;
    Vue.prototype.i18n_filename = window.abacaConfig.i18n_filename;
    Vue.prototype.defaultImg = window.abacaConfig.defaultImg;
    Vue.prototype.customEquipmentImg = window.abacaConfig.customEquipmentImg;
    Vue.prototype.URL_GetExcel =
      window.abacaConfig.urls.URL_GetExcel + window.abacaConfig.excel_config;
    Vue.prototype.URL_GetEquipments = window.abacaConfig.urls.URL_GetEquipments;
  } else {
    Vue.prototype.URL_ContextPath = process.env.VUE_APP_URL_ContextPath;
    Vue.prototype.URL_JsonData = process.env.VUE_APP_URL_URL_JSONdata;
    Vue.prototype.URL_GetPDF = process.env.VUE_APP_URL_URL_GetPDF;
    Vue.prototype.URL_SendStats = process.env.VUE_APP_URL_URL_SendStats;
    Vue.prototype.i18n_filename = process.env.VUE_APP_i18n_FILENAME;
    Vue.prototype.defaultImg = process.env.VUE_APP_defaultImg;
    Vue.prototype.customEquipmentImg = process.env.VUE_APP_customEquipmentImg;
    Vue.prototype.URL_GetExcel = process.env.VUE_APP_URL_GetExcel;
    Vue.prototype.URL_GetEquipments = process.env.VUE_APP_URL_GetEquipments;
  }



  forkJoin([
    getGlobalData(),
    loadJSONLabels(
      process.env.VUE_APP_I18N_LOCALE || "fr",
      Vue.prototype.i18n_filename || "i18n-ABACA"
    ),
  ])
    .toPromise()
    .then(([globalData, localeMessages]) => {
      //set local mesages
      i18n.setLocaleMessage(process.env.VUE_APP_I18N_LOCALE || "fr", localeMessages.data);
      store.dispatch(ACTION_INIT_DATAS, globalData);
      store.dispatch(ACTION_INIT_DEFAULT_SETTINGS, store.state.globalAppDataModule.settings);
      store.commit(UPDATE_ANSWERS, mapQuestionDtoToAnswers(globalData.appData.questions));
      store.commit(UPDATE_LOADED, true);
    });
}

new Vue({
  router,
  beforeCreate: initInstanceProperties,
  i18n,
  store,
  render: (h) => h(App),
}).$mount("#app");
